import { createModel } from '@rematch/core';

// Types
import type { RootModel } from './index';

type EditModeState = {
  isEnabled: boolean;
};

// Intentionally not persisted (no localStorage/useLocalStorage) - every fresh
// page load or refresh should start locked in view-only mode, per-tab.
const DEFAULT_STATE: EditModeState = {
  isEnabled: false,
};

export const edit_mode = createModel<RootModel>()({
  state: DEFAULT_STATE,
  reducers: {
    setEnabled(state, payload: boolean) {
      return {
        ...state,
        isEnabled: payload,
      };
    },
    resetState() {
      return DEFAULT_STATE;
    },
  },
  effects: () => ({}),
});
